import SystemKeyboardKeyItem from "../items/SystemKeyboardKeyItem";


export function PositiveDecimalKeyboard({onKeyButtonPressed, isKeyButtonDisabled}) {
    // Used through games and exercisers that expect positive decimal as
    // user answer

    // PROPERTIES
    const positiveDecimalKeys = [
        '1', '2', '3', '4',
        '5', '6', '7', '8'];

    // BUILD
    return (
        <div className={"w-full flex flex-col space-y-[12px]"}>
            <div className="w-full grid grid-cols-4 gap-[12px]">
                {positiveDecimalKeys.map((item, index) => (
                    <SystemKeyboardKeyItem key={index}
                                           item={item}
                                           onKeyButtonPressed={onKeyButtonPressed}
                                           isKeyButtonDisabled={isKeyButtonDisabled} />
                ))}
            </div>
            <div className={"w-full grid grid-cols-2 gap-[12px]"}>
                <div className={"flex-1 grid grid-cols-2 gap-[12px]"}>
                    <SystemKeyboardKeyItem item={'9'}
                                           onKeyButtonPressed={onKeyButtonPressed}
                                           isKeyButtonDisabled={isKeyButtonDisabled} />
                    <SystemKeyboardKeyItem item={'0'}
                                           onKeyButtonPressed={onKeyButtonPressed}
                                           isKeyButtonDisabled={isKeyButtonDisabled} />
                </div>
                <div className={"flex-1"}>
                    <SystemKeyboardKeyItem item={','}
                                           onKeyButtonPressed={onKeyButtonPressed}
                                           isKeyButtonDisabled={isKeyButtonDisabled} />
                </div>
            </div>
        </div>
    );
}